@if (chapters().isLoadingChapters) {
  <app-loading-indicator></app-loading-indicator>
} @else {
  @if (showProgress()) {
    @if (chapterStats(); as cs) {
      <div class="m-4">
        <progress
          class="progress progress-success"
          [value]="cs.confirmedChapters"
          [max]="cs.chapters"
        ></progress>
        <div class="flex flex-row justify-between text-sm opacity-60">
          <span>
            {{
              "instruction-details.chapters.confirmed-percentage"
                | translate: { percentage: cs.confirmedPercentage }
            }} </span
          ><span>
            {{
              "instruction-details.chapters.confirmed-chapters"
                | translate
                  : {
                      chapters: cs.chapters,
                      confirmedChapters: cs.confirmedChapters
                    }
            }}
          </span>
        </div>
      </div>
    }
  }

  <ul class="list">
    @for (
      pair of sortedChaptersWithConfirmations().chapterWithConfirmation;
      track $index
    ) {
      <li class="list-row">
        <div class="text-4xl font-thin tabular-nums opacity-30">
          {{ pair.chapter.order }}
        </div>
        <div class="list-col-grow">
          <div class="text-xl">
            {{ pair.chapter.title }}
          </div>
          @if (showProgress()) {
            @if (pair.chapterConfirmation) {
              <div
                class="text-success text-sm"
                [class.text-success]="pair.chapterConfirmation != undefined"
              >
                {{ "instruction-details.chapters.confirmed" | translate }}
              </div>
            } @else {
              <div class="text-sm opacity-60">
                {{ "instruction-details.chapters.not-confirmed" | translate }}
              </div>
            }
          } @else {
            <div>
              <!-- when we have no progress (e.g. Instruction Type: Information) we do not show status -->
            </div>
          }
        </div>

        <button
          class="btn btn-primary"
          [class.btn-success]="pair.chapterConfirmation != undefined"
          (click)="selectChapter(pair.chapter)"
          [disabled]="selectedChapter?.name == pair.chapter.name"
        >
          @if (pair.chapterConfirmation == undefined && showProgress()) {
            {{ "instruction-details.chapters.confirm-chapter" | translate }}
          } @else {
            {{ "instruction-details.chapters.open-chapter" | translate }}
          }
        </button>
      </li>
    }
  </ul>
}
